import { Source } from 'plyr'

import { GUIDES_PATH, CKLA_HUB } from 'app/constants/api.constants'

export function getVideoSourcesList(videoPath: string | string[]): Source[] {
  const isSamePath = !Array.isArray(videoPath)

  return [
    {
      src: `${isSamePath ? videoPath : videoPath[0]}_1080.mp4`,
      type: 'video/mp4',
      size: 1080,
    },
    {
      src: `${isSamePath ? videoPath : videoPath[1]}_720.mp4`,
      type: 'video/mp4',
      size: 720,
    },
    {
      src: `${isSamePath ? videoPath : videoPath[2]}_360.mp4`,
      type: 'video/mp4',
      size: 360,
    },
  ]
}

export function getPosterURL(posterPath: string) {
  return `${posterPath}.jpg`
}

export function getGuidePosterURL(guideName: string) {
  return `${GUIDES_PATH}/${guideName}.jpg`
}

export function getGuideVideoSources(guideName: string) {
  return getVideoSourcesList(`${GUIDES_PATH}/${guideName}`)
}

export function getTeacherGuideCarouselImg(path: string) {
  return `${CKLA_HUB}/${path}`
}
